import React from 'react';

import Follow from './Follow';
import HeaderMoreActions from './HeaderMoreActions';

import type { HeaderProps } from '../types';

import styles from './HeaderActions.css';

type HeaderActionsProps = Pick<
  HeaderProps,
  | 'pageId'
  | 'isFollowingPage'
  | 'globalId'
  | 'pageUrl'
  | 'ctaType'
  | 'isSubpage'
> & {
  isEditor: boolean;
};

const HeaderActions = ({
  pageId,
  isFollowingPage,
  globalId,
  pageUrl,
  isEditor,
  ctaType,
}: HeaderActionsProps) => (
  <>
    <Follow
      pageId={pageId}
      isFollowingPage={isFollowingPage}
      className={styles.cta}
    />
    <HeaderMoreActions
      globalId={globalId}
      pageUrl={pageUrl}
      isEditor={isEditor}
      ctaType={ctaType}
    />
  </>
);

export default HeaderActions;
